import { useNavigate } from 'react-router-dom';
import { Button } from '@elva/ui';

/**
 * Shown for any unknown address inside the app shell (spec 49 §2) — in place of
 * React Router's raw developer error screen.
 */
export function NotFoundPage() {
  const navigate = useNavigate();
  return (
    <div className="cal-fade mx-auto flex min-h-0 w-full max-w-[560px] flex-1 flex-col items-center justify-center px-6 py-20 text-center">
      <h1 className="m-0 font-[var(--font-display)] text-[26px] font-semibold tracking-[-0.02em] text-[var(--text-primary)]">
        Page not found
      </h1>
      <p className="m-0 mt-2 text-[13.5px] leading-[1.6] text-[var(--text-secondary)]">
        This page doesn’t exist or has moved.
      </p>
      <Button variant="primary" size="sm" className="mt-5" onClick={() => { void navigate('/dashboard'); }}>
        Go to the Dashboard
      </Button>
    </div>
  );
}
